/**
 * If a mailing address field requires conditional logic based on a general delivery area.
 */
export default function useGeneralDelivery() {
    const generalDeliveryRegex =
        /(p\.?\s?(o|b)\.?(\s?(box|drawer|vox))?|post\soffice\s(box)?|p\/o\sbox|cluster\sbox|box)(\s?\d+)|general\sdelivery/i;

    const matchGeneralDelivery = (address?: string) =>
        address
            ? generalDeliveryRegex.exec(address.toLowerCase()) !== null
            : false;

    return {
        /**
         * passing in `undefined`, `null`, or `""` as an argument will return `false`
         */
        matchGeneralDelivery,
    };
}
